<template>
  <b-card class="mt-3">
    <div class="d-flex align-items-end">
      <b-icon icon="exclamation-triangle-fill" class="text-warning mr-2" font-scale="2"/>
      <h5 class="mb-0" v-translate>
        There are no results for your search.
        Please change the search criteria.
      </h5>
    </div>
  </b-card>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

</style>
